import createStore from './redux/store/configureStore'

export const store = createStore()

export default store
